export const DefaultDateAndTimeFormat = 'dd/MM/yyyy HH:mm';
